import { z } from "zod";

const MenuGroupReferenceSchema = z.object({
  menuGroupId: z
    .number()
    .int({ message: "Menu Group ID must be an integer" })
    .positive()
    .readonly(),
  price: z.number().nonnegative().readonly(),
  /**
   * Full ancestor chain from root → this group, e.g. [100, 200, 300].
   * Used by POS for nearest-ancestor pricing resolution and multi-parent
   * disambiguation. Optional for backward compat with legacy entries.
   */
  ancestorPath: z
    .array(z.number().int().positive())
    .optional()
    .readonly(),
});

export type MenuGroupReferenceType = z.infer<typeof MenuGroupReferenceSchema>;
export default MenuGroupReferenceSchema;
